import React, { Component } from "react";
import { Api } from "../utils/api";
import { Formik, Field, Form, validateYupSchema } from "formik";
import * as Yup from "yup";
import LoadingBar from 'react-top-loading-bar';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { createMuiTheme, ThemeProvider, withTheme } from '@material-ui/core/styles';
import MainHeader from "../components/main-header";
import MainFooter from "../components/main-footer";
import axios from 'axios';

import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';


class ResultsPageView extends Component {

    static config = {
        development: {
            baseUrl: process.env.REACT_APP_SITE_DEV_URL || 'localhost:3000'
        },
        staging: {
            baseUrl: process.env.REACT_APP_SITE_STG_URL
        },
        production: {
            baseUrl: process.env.REACT_APP_SITE_PRD_URL
        }
    };
    static ENV = process.env.REACT_APP_NODE_ENV || 'development';
    static currentConfig = this.config[this.ENV];

    constructor() {
        super();
        this.api = new Api();
        this.getValences = this.getValences.bind(this);
        this.getServices = this.getServices.bind(this);
        this.getPlaces = this.getPlaces.bind(this);
        this.getNrEstablishmentsbyCounty = this.getNrEstablishmentsByCounty.bind(this);
        this.searchEstablishments = this.searchEstablishments.bind(this);
        this.searchEstablishmentsCount = this.searchEstablishmentsCount.bind(this);
        this.getDistrictInfo = this.getDistrictInfo.bind(this);
        this.getCountyInfo = this.getCountyInfo.bind(this);
        this.getLocalGuides = this.getLocalGuides.bind(this);
        this.params = new URLSearchParams(window.location.search);
        this.showFiltersMobile = this.showFiltersMobile.bind(this);
        this.hideFiltersMobile = this.hideFiltersMobile.bind(this);
        this.getTitle = this.getTitle.bind(this);
      }
    
      state = {
        valences:null,
        services_32: null,
        services_60: null,
        places:null,
        local:null,
        nr_establishments_by_county: null,
        search_establishments: null,
        search_establishments_count: null,
        district_info: null,
        county_info: null,
        local_guides: null,
        progress: 0, 
        setProgress: 0
      };
    
      async componentDidMount() {
        let service = this.params.get('tipologia') == null ? "0" : this.params.get('tipologia');
        this.getValences();
        // valores do ids dos inputs dos radio_services vêm da base de dados, enato é preciso esperar que esteja preenchido
        await this.getServices();
        this.getPlaces();
        this.getNrEstablishmentsByCounty(service);
        this.searchEstablishments();
        await this.searchEstablishmentsCount();
        this.getDistrictInfo();
        this.getCountyInfo();
        this.getLocalGuides();
        this.getTitle();
        
        let input_id = ("radio_service"+(this.params.get('tipologia')) );
        let mobile_input_id = ("mobile_radio_service"+(this.params.get('tipologia')) );
        //console.log(input_id);
        if( document.getElementById(input_id) ){
            document.getElementById(input_id).checked=true;
        }
        if(document.getElementById(mobile_input_id)){
            document.getElementById(mobile_input_id).checked=true;
        }

        if(document.getElementById("check14"))
            document.getElementById("check14").checked=this.params.get('mais-recomendados')!=null
        if(document.getElementById("check15"))
            document.getElementById("check15").checked=this.params.get('com-foto')!=null
        if(document.getElementById("checkbox_ordbyrec_mobile"))
            document.getElementById("checkbox_ordbyrec_mobile").checked=this.params.get('mais-recomendados')!=null
        if(document.getElementById("checkbox_wphoto_mobile"))
            document.getElementById("checkbox_wphoto_mobile").checked=this.params.get('com-foto')!=null
      }

      validationSchemaSearch = Yup.object().shape({
        keywords: Yup.string()
        });

    // método p mudar o title da pagina de acordo com a pesquisa
    // muda tb as meta robots dependendo do ambiente em q estamos
    getTitle(){
        
        if(process.env.REACT_APP_NODE_ENV != 'production'){
            document.head.getElementsByTagName("meta")[0].content = "noindex,nofollow";
            document.head.getElementsByTagName("link")[0].rel = "canonical";
            document.head.getElementsByTagName("link")[0].href = "http://www.laresonline.pt/pt/pesquisa";
            console.log(document.head.getElementsByTagName("link")[0]);
        }
        else{
            document.head.getElementsByTagName("meta")[0].content = "index,follow"; 
        } 

        if(this.state.search_establishments_count != undefined){
            if(this.state.search_establishments_count == 0){
                document.getElementsByTagName("title")[0].innerText = 'Outras ofertas para idosos | Lares Online';
            }
            else{
                if(this.params.get('valencia') != null && this.params.get('distrito') == null && this.params.get('concelho') == null){
                    if (this.state.search_establishments != null){
                        document.getElementsByTagName("title")[0].innerText = this.state.search_establishments_count + " " + this.state.search_establishments[0].valence + " para Idosos " + (this.params.get("pagina") > 1 ? " (página " + this.params.get("pagina") + "/"+ parseInt((this.state.search_establishments_count/10)+1) + ")" : '') + " | Lares Online"; 
                    }
                }else if(this.params.get('valencia') != null && this.params.get('distrito') != null && this.params.get('concelho') == null){
                    if (this.state.search_establishments != null){
                        document.getElementsByTagName("title")[0].innerText = this.state.search_establishments_count + " " + this.state.search_establishments[0].valence + " para Idosos em " + this.state.search_establishments[0].distrito + " (Distrito) " + (this.params.get("pagina") > 1 ? " (página " + this.params.get("pagina") + "/"+ parseInt((this.state.search_establishments_count/10)+1) + ")" : '') + " | Lares Online";
                    }
                }else if(this.params.get('valencia') != null && this.params.get('distrito') == null && this.params.get('concelho') != null){
                    if (this.state.search_establishments != null){
                        document.getElementsByTagName("title")[0].innerText = this.state.search_establishments_count + " " + this.state.search_establishments[0].valence + " para Idosos em "+ this.state.search_establishments[0].concelho + " (Concelho) " + (this.params.get("pagina") > 1 ? " (página " + this.params.get("pagina") + "/"+ parseInt((this.state.search_establishments_count/10)+1) + ")" : '') + " | Lares Online";
                    }
                }else if(this.params.get('valencia') == null && this.params.get('distrito') != null && this.params.get('concelho') == null){
                    if (this.state.search_establishments != null){
                        document.getElementsByTagName("title")[0].innerText = this.state.search_establishments_count + " Equipamentos e Serviços para Idosos em " + this.state.search_establishments[0].distrito + " (Distrito) " + (this.params.get("pagina") > 1 ? " (página " + this.params.get("pagina") + "/"+ parseInt((this.state.search_establishments_count/10)+1) + ")" : '') + " | Lares Online";
                    }
                }else if(this.params.get('valencia') == null && this.params.get('distrito') == null && this.params.get('concelho') != null){
                    if (this.state.search_establishments != null){
                        document.getElementsByTagName("title")[0].innerText = this.state.search_establishments_count + " Equipamentos e Serviços para Idosos em " + this.state.search_establishments[0].concelho + " (Concelho)" + (this.params.get("pagina") > 1 ? " (página " + this.params.get("pagina") + "/"+ parseInt((this.state.search_establishments_count/10)+1) + ")" : '') + " | Lares Online";
                    }
                }else{
                    document.getElementsByTagName("title")[0].innerText = this.state.search_establishments_count + ' Equipamentos e Serviços para Idosos em Portugal' + (this.params.get("pagina") > 1 ? " (página " + this.params.get("pagina") + "/"+ parseInt((this.state.search_establishments_count/10)+1) + ")" : '') + ' | Lares Online';
                } 
            }
        }
    }

      //lista de todas as valencias
      getValences(request = "valences") {
        return this.api.get(`/results_page`, {request})
        .then(({data = null}) => {
          this.setState({valences: data} );
          return data;
        }); 
      } 

      //lista de todos as tipologias de lares e residencias (service_id 32 ) e de apoio domiciliario (service_id 60)
      getServices(request = "services") {
        return this.api.get(`/results_page`, {request})
        .then(({data = null}) => {
          this.setState({services_32: data.services_32} );
          this.setState({services_60: data.services_60} );
          return data;
        });  
      } 

      //lista de todos distritos e concelhos
      getPlaces(request = "places") {
        return this.api.get(`/results_page`, {request})
        .then(({data = null}) => {
          this.setState({places: data});
          return data;
        }); 
      }

      //informação para a barra no main - distritos
      getDistrictInfo(
          request = "district_info",  
          district = this.params.get('distrito') == null ? 0 : this.params.get('distrito')
          ){
        let valence = this.params.get('valencia') == null ? 0 : this.params.get('valencia');
        return this.api.get(`/results_page`, {request, valence, district})
        .then(({data = null}) => {
          this.setState({district_info: data});
          return data;
        });
      }

      //informação para a barra no main - concelhos
      getCountyInfo(
          request = "county_info", 
          district = this.params.get('distrito') == null ? 0 : this.params.get('distrito'),
          county= this.params.get('concelho') == null ? 0 : this.params.get('concelho')
          ){
        let valence = this.params.get('valencia') == null ? 0 : this.params.get('valencia');
        return this.api.get(`/results_page`, {request, valence, district, county})
        .then(({data = null}) => {
          this.setState({county_info: data});
          return data;
        });
      }

        //informação para o Guia de rodapé
        getLocalGuides(
            request = "local_guides", 
            district = this.params.get('distrito') == null ? 0 : this.params.get('distrito'),
            county= this.params.get('concelho') == null ? 0 : this.params.get('concelho')
            ){
            return this.api.get(`/results_page`, {request, district, county})
            .then(({data = null}) => {
                this.setState({local_guides: data});
                return data;
            });
        }

        getNrEstablishmentsByCounty(service) {
            let request = "nr_establishments_by_county";
            let valence = this.params.get('valencia') == null ? 0 : this.params.get('valencia');
            let district = this.params.get('distrito') == null ? 0 : this.params.get('distrito');
        return this.api.get(`/results_page`, {request, valence, service, district})
        .then(({data = null}) => {
            this.setState({nr_establishments_by_county: data});
            return data;
        }); 
        }

        searchEstablishments(
            request = "search_establishments", 
            valence = this.params.get('valencia') == null ? 0 : this.params.get('valencia'), 
            service = this.params.get('tipologia') == null ? "0" : this.params.get('tipologia'),
            district = this.params.get('distrito') == null ? 0 : this.params.get('distrito'),
            county = this.params.get('concelho') == null ? 0 : this.params.get('concelho'),
            keywords = this.params.get('palavras-chave') == null ? "" : this.params.get('palavras-chave').replaceAll(20,""),
            ordbyrec = this.params.get('mais-recomendados') == null ? 0 : 1,
            ordbynew = this.params.get('mais-recentes') == null ? 0 : 1,
            ordbyfav = this.params.get('favoritos') == null ? 0 : 1,
            wphoto = this.params.get('com-foto') == null ? 0 : 1,
            resultspage = this.params.get('pagina') == null ? 1 : this.params.get('pagina')
            ) {
            this.api.get(`/results_page`, {request, valence, service, district, county, keywords, ordbyrec, ordbynew, ordbyfav, wphoto, resultspage})
            .then(({data = null}) => {
                this.setState({search_establishments: data});
                this.setState({progress: 100});
                this.getTitle();
            }); 
            
        }

        searchEstablishmentsCount(
            request = "search_establishments_count", 
            valence = this.params.get('valencia') == null ? 0 : this.params.get('valencia'),
            service = this.params.get('tipologia') == null ? "0" : this.params.get('tipologia'),
            district = this.params.get('distrito') == null ? 0 : this.params.get('distrito'),
            county= this.params.get('concelho') == null ? 0 : this.params.get('concelho'),
            keywords = this.params.get('palavras-chave') == null ? "" : this.params.get('palavras-chave').replaceAll(20,""),
            ordbyrec = this.params.get('mais-recomendados') == null ? 0 : 1,
            ordbynew = this.params.get('mais-recentes') == null ? 0 : 1,
            ordbyfav = this.params.get('favoritos') == null ? 0 : 1,
            wphoto = this.params.get('com-foto') == null ? 0 : 1,
            ) {
        return this.api.get(`/results_page`, {request, valence, service, district, county, ordbyrec, ordbynew, ordbyfav, keywords, wphoto})
        .then(({data = null}) => {
            this.setState({search_establishments_count: data[0].count});
            return data;
        }); 
        }

        showFiltersMobile(){
            const filters_mobile = document.getElementById("filter_full_section");
            filters_mobile.classList.remove("d-none");
        }

        hideFiltersMobile(){
            const filters_mobile = document.getElementById("filter_full_section");
            filters_mobile.classList.add("d-none");
        }

        resetFiltersMobile(){
            const filters_mobile = document.getElementsByClassName("mobile_filter_checkbox");
            for(let i = 0; i<13; i++){
                    filters_mobile[i].checked = false;
                    filters_mobile[i].value = null;
            } 
        }


    render() {

        const environment_url = window.location.origin;
        const valences = this.state.valences;
        const services_32 = this.state.services_32;
        const services_60 = this.state.services_60;
        const places = this.state.places;
        const nrs_by_county = this.state.nr_establishments_by_county;
        const establishments = this.state.search_establishments;
        const establishments_count = this.state.search_establishments_count;
        const district_info = this.state.district_info;
        const county_info = this.state.county_info;
        const local_guides = this.state.local_guides;

        //console.log(establishments);

        const valen = this.params.get('valencia') == null ? 0 : this.params.get('valencia'); 
        const service = this.params.get('tipologia') == null ? 0 : this.params.get('tipologia');
        const district = this.params.get('distrito') == null ? 0 : this.params.get('distrito');
        const county = this.params.get('concelho') == null ? 0 : this.params.get('concelho');
        let keywords = this.params.get('palavras-chave') == null ? "" : this.params.get('palavras-chave').replaceAll(20,""); 
        const ordbyrec = this.params.get('mais-recomendados') == null ? 0 : 1;
        const ordbynew = this.params.get('mais-recentes') == null ? 0 : 1;
        const ordbyfav = this.params.get('favoritos') == null ? 0 : 1;
        const wphoto = this.params.get('com-foto') == null ? 0 : 1;
        const resultspage = this.params.get('pagina') == null ? 1 : this.params.get('pagina');
        const page_number_parsed = parseInt(resultspage);
        const page_number = page_number_parsed > 0 ? page_number_parsed : 1;

        const theme = createMuiTheme({
            props: {
              // Name of the component ⚛️
              MuiAutocomplete: {
                // The default props to change
                closeIcon: false,
                forcePopupIcon: false,
                freeSolo: true,
              },
            },
            overrides: {
                // Nome da folha de estilo ⚛️
                MuiAutocomplete: {
                  // Nome da regra
                  input: {
                    // Algum CSS
                    fontFamily: 'Lato',
                    fontSize:12,
                    color:'#797C7C',
                    marginLeft:12,
                    height: 24,
                  },
                  option:{
                    fontFamily: 'Lato',
                    fontSize:12,
                    color:'#797C7C',
                  },           
                },
            },
          });

        function getLink(){
            let link = "";
            link = ("?")+(valen != 0 ?"valencia="+valen:"")+(service != 0 ?"&tipologia="+service:"")+(district != 0 ?"&distrito="+district:"")+(county != 0 ?"&concelho="+county:"")+(keywords != "" ?"&palavras-chave="+keywords:"")+(ordbyrec != 0 ?"&mais-recomendados":"")+(ordbynew != 0 ?"&mais-recentes":"")+(ordbyfav != 0 ?"&favoritos":"")+(wphoto != 0 ?"&com-foto":"")+(resultspage != null ?"&pagina=":"");
            return link;
        }

        function footprintsDistrictLink(){
            let link = "";
            link = ("?")+(valen != 0 ?"valencia="+valen:"")+("&distrito="+ (establishments[0].distrito_url).replace('distrito-', ''));
            return link;
        }

        function footprintsCountyLink(){
            let link = "";
            link = ("?")+(valen != 0 ?"valencia="+valen:"")+(district != 0 ?"&distrito="+district:"")+(county != 0 ?"&concelho="+county:"");
            return link;
        }

        function getResultsOrdFav(){
            let link = "";
            link = ("?")+(valen != 0 ?"valencia="+valen:"")+(service != 0 ?"&tipologia="+service:"")+(district != 0 ?"&distrito="+district:"")+(county != 0 ?"&concelho="+county:"")+(keywords != "" ?"&palavras-chave="+keywords:"")+("&favoritos")+(wphoto != 0 ?"&com-foto":"");
            return link;
        }

        function getResultsOrdNew(){
            let link = "";
            link = ("?")+(valen != 0 ?"valencia="+valen:"")+(service != 0 ?"&tipologia="+service:"")+(district != 0 ?"&distrito="+district:"")+(county != 0 ?"&concelho="+county:"")+(keywords != "" ?"&palavras-chave="+keywords:"")+("&mais-recentes")+(wphoto != 0 ?"&com-foto":"");
            return link;
        }


        let pages = []

        function pagination() { 
            for (let i = 0; i < 2; i++){
                pages.push(
                    <li class={(establishments_count/10) > page_number+i ?"page-item p-1":"page-item p-1 d-none"}>
                        <a title={"Página " + (page_number+i+1)} class="page-link" href={getLink()+(page_number+i+1)}>{page_number+i+1} </a>
                    </li> 
                );
            }
            return pages;
        }

        function changeColors(e) {
            if (e.target.id == 'item-box' || e.target.className == 'item-content'){
                let item_title = e.target.querySelector("#establishment-title");
                let item_button = e.target.querySelector("#item-button");
                let item_button_link = e.target.querySelector("#item-button-link"); 
                //console.log(item_title);
                //console.log(item_button);
                item_title.classList.add('establishment-title');
                item_button.classList.add('item-button');
                item_button_link.classList.add('item-button-link');
            }

            else if(e.target.id == 'item-img'){
                let item_title = e.target.parentNode.parentNode.parentNode.parentNode.querySelector("#establishment-title");
                let item_button = e.target.parentNode.parentNode.parentNode.parentNode.querySelector("#item-button");
                let item_button_link = e.target.parentNode.parentNode.parentNode.parentNode.querySelector("#item-button-link");
                item_title.classList.add('establishment-title');
                item_button.classList.add('item-button');
                item_button_link.classList.add('item-button-link');
            }

            else if (e.target.className == 'item-thumb') {
                let item_title = e.target.parentNode.parentNode.querySelector("#establishment-title");
                let item_button = e.target.parentNode.parentNode.querySelector("#item-button");
                let item_button_link = e.target.parentNode.parentNode.querySelector("#item-button-link");
                item_title.classList.add('establishment-title');
                item_button.classList.add('item-button');
                item_button_link.classList.add('item-button-link');
            }
           
            else if (e.target.className == 'item-content-middle' || e.target.className == 'item-content-top' || e.target.className == 'item-last') {
                let item_title = e.target.parentNode.querySelector("#establishment-title");
                let item_button = e.target.parentNode.querySelector("#item-button");
                let item_button_link = e.target.parentNode.querySelector("#item-button-link");
                //console.log(item_title);
                item_title.classList.add('establishment-title');
                item_button.classList.add('item-button');
                item_button_link.classList.add('item-button-link');
            }

        }

        function removeColors() {
            document.body.querySelectorAll(".item-button").forEach(el => {
                el.classList.remove('item-button');
            });
            document.body.querySelectorAll(".establishment-title").forEach(el => {
                el.classList.remove('establishment-title');
            });
            document.body.querySelectorAll(".item-button-link").forEach(el => {
                el.classList.remove('item-button-link');
            });
        } 

        function getLocalName(local) {
            if(places){
                const localidade = places.find(place=>place.url == local);
                return localidade.name;
            }
        }

        
        function clearKeywords(){
            let keywords_input = document.getElementById("keywords_input");
            keywords_input.value = '';
            keywords = '';
        }

        function clearLocal(){
            let local_input = document.getElementById("autocomplete");
            local_input.value = '';
        }

        function hideHeader(){
            let header = document.getElementById("header");
            header.classList.add("header-hide");
        }

        function showHeader(){
            let header = document.getElementById("header");
            header.classList.remove("header-hide");
        }

        function removeUnderline(){
            document.body.querySelectorAll(".button-border").forEach(btn_detalhe => {
                btn_detalhe.classList.add('remove_underline_to_btn');
            });
                
        }

        //** */
        //** */
        
        return (
            <div>
                {/* <LoadingBar color="blue" progress={this.state.progress} onLoaderFinished={() => this.setState({setProgress:0})} /> */}

                <div id="header">
                    <MainHeader/>
                </div>

                <main>
                    <div class={
                        (district=='aveiro' ||
                            district=='beja' ||
                            district=='braga' ||
                            district=='braganca' ||
                            district=='castelo-branco' ||
                            district=='coimbra' ||
                            district=='evora' ||
                            district=='faro' ||
                            district=='guarda' ||
                            district=='ilha-da-madeira' ||
                            district=='ilha-das-flores' ||
                            district=='ilha-de-porto-santo' ||
                            district=='ilha-de-santa-maria' ||
                            district=='ilha-de-sao-jorge' ||
                            district=='ilha-de-sao-miguel' ||
                            district=='ilha-do-corvo' ||
                            district=='ilha-do-faial' ||
                            district=='ilha-do-pico' ||
                            district=='ilha-graciosa' ||
                            district=='ilha-terceira' ||
                            district=='leiria' ||
                            district=='lisboa' ||
                            district=='portalegre' ||
                            district=='porto' ||
                            district=='santarem' ||
                            district=='setubal' ||
                            district=='viana-do-castelo' ||
                            district=='vila-real' ||
                            district=='viseu' )    && county == 0 ? "" : "d-none" }>
                        {district_info != '' && (
                        <div class="box">
                            {district_info && district_info.map(district_inf  => (
                                <div class={district_inf.image_district == null || district_inf.text_district == null ? "d-none" : ""}>
                                    <div class="hero-area position-relative">
                                        <div class="container-fluid p-0 fix">
                                            <div class="row">
                                                <div class="col-sm-12 hero">
                                                    <div class="desktop-bg">
                                                        <img class="img d-none d-md-block" src={"https://www.laresonline.pt"+district_inf.image_district} alt={"foto-distrito-"+district_inf.district} />
                                                    </div>
                                                    <div class="mobile-bg">
                                                        <img class="img" src="img/hero-small-bg.png" alt="cor-de-fundo-mobile" />
                                                        <div class="hero-caption-heading">
                                                            <h2>{district_inf.district}</h2>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="container">
                                            <div class="hero-caption-box">
                                                <div class="hero-caption-heading d-none d-md-block">
                                                    <h2>{district_inf.district}</h2>
                                                </div>
                                                <div class="hero-caption-content" id="style-1">
                                                    <p>{district_inf.text_district}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        )}
                    </div>
                    
                    
                    {/* Hero end
                    breadcrumb-area */}
                    <div class={district == 0 && (
                                county=='abrantes' ||
                                county=='agueda' ||
                                county=='aguiar-da-beira' ||
                                county=='alandroal' ||
                                county=='albergaria-a-velha' ||
                                county=='albufeira' ||
                                county=='alcacer-do-sal' ||
                                county=='alcanena' ||
                                county=='alcobaca' ||
                                county=='alcochete' ||
                                county=='alcoutim' ||
                                county=='alenquer' ||
                                county=='alfandega-da-fe' ||
                                county=='alijo' ||
                                county=='aljezur' ||
                                county=='aljustrel' ||
                                county=='almada' ||
                                county=='almeida' ||
                                county=='almeirim' ||
                                county=='almodovar' ||
                                county=='alpiarca' ||
                                county=='alter-do-chao' ||
                                county=='alvaiazere' ||
                                county=='alvito' ||
                                county=='amadora' ||
                                county=='amarante' ||
                                county=='amares' ||
                                county=='anadia' ||
                                county=='angra-do-heroismo' ||
                                county=='ansiao' ||
                                county=='arcos-de-valdevez' ||
                                county=='arganil' ||
                                county=='armamar' ||
                                county=='arouca' ||
                                county=='arraiolos' ||
                                county=='arronches' ||
                                county=='arruda-dos-vinhos' ||
                                county=='aveiro' ||
                                county=='avis' ||
                                county=='azambuja' ||
                                county=='baiao' ||
                                county=='barcelos' ||
                                county=='barrancos' ||
                                county=='barreiro' ||
                                county=='batalha' ||
                                county=='beja' ||
                                county=='belmonte' ||
                                county=='benavente' ||
                                county=='bombarral' ||
                                county=='borba' ||
                                county=='boticas' ||
                                county=='braga' ||
                                county=='braganca' ||
                                county=='cabeceiras-de-basto' ||
                                county=='cadaval' ||
                                county=='caldas-da-rainha' ||
                                county=='ilha-da-madeira-calheta' ||
                                county=='ilha-de-sao-jorge-calheta' ||
                                county=='camara-de-lobos' ||
                                county=='caminha' ||
                                county=='campo-maior' ||
                                county=='cantanhede' ||
                                county=='carrazeda-de-ansiaes' ||
                                county=='carregal-do-sal' ||
                                county=='cartaxo' ||
                                county=='cascais' ||
                                county=='castanheira-de-pera' ||
                                county=='castelo-branco' ||
                                county=='castelo-de-paiva' ||
                                county=='castelo-de-vide' ||
                                county=='castro-daire' ||
                                county=='castro-marim' ||
                                county=='castro-verde' ||
                                county=='celorico-da-beira' ||
                                county=='celorico-de-basto' ||
                                county=='chamusca' ||
                                county=='chaves' ||
                                county=='cinfaes' ||
                                county=='coimbra' ||
                                county=='condeixa-a-nova' ||
                                county=='constancia' ||
                                county=='coruche' ||
                                county=='corvo' ||
                                county=='covilha' ||
                                county=='crato' ||
                                county=='cuba' ||
                                county=='elvas' ||
                                county=='entroncamento' ||
                                county=='espinho' ||
                                county=='esposende' ||
                                county=='estarreja' ||
                                county=='estremoz' ||
                                county=='evora' ||
                                county=='fafe' ||
                                county=='faro' ||
                                county=='felgueiras' ||
                                county=='ferreira-do-alentejo' ||
                                county=='ferreira-do-zezere' ||
                                county=='figueira-da-foz' ||
                                county=='figueira-de-castelo-rodrigo' ||
                                county=='figueiro-dos-vinhos' ||
                                county=='fornos-de-algodres' ||
                                county=='freixo-de-espada-a-cinta' ||
                                county=='fronteira' ||
                                county=='funchal' ||
                                county=='fundao' ||
                                county=='gaviao' ||
                                county=='gois' ||
                                county=='golega' ||
                                county=='gondomar' ||
                                county=='gouveia' ||
                                county=='grandola' ||
                                county=='guarda' ||
                                county=='guimaraes' ||
                                county=='horta' ||
                                county=='idanha-a-nova' ||
                                county=='ilhavo' ||
                                county=='faro-lagoa' ||
                                county=='ilha-de-sao-miguel-lagoa' ||
                                county=='lagos' ||
                                county=='lajes-das-flores' ||
                                county=='lajes-do-pico' ||
                                county=='lamego' ||
                                county=='leiria' ||
                                county=='lisboa' ||
                                county=='loule' ||
                                county=='loures' ||
                                county=='lourinha' ||
                                county=='lousa' ||
                                county=='lousada' ||
                                county=='macao' ||
                                county=='macedo-de-cavaleiros' ||
                                county=='machico' ||
                                county=='madalena' ||
                                county=='mafra' ||
                                county=='maia' ||
                                county=='mangualde' ||
                                county=='manteigas' ||
                                county=='marco-de-canaveses' ||
                                county=='marinha-grande' ||
                                county=='marvao' ||
                                county=='matosinhos' ||
                                county=='mealhada' ||
                                county=='meda' ||
                                county=='melgaco' ||
                                county=='mertola' ||
                                county=='mesao-frio' ||
                                county=='mira' ||
                                county=='miranda-do-corvo' ||
                                county=='miranda-do-douro' ||
                                county=='mirandela' ||
                                county=='mogadouro' ||
                                county=='moimenta-da-beira' ||
                                county=='moita' ||
                                county=='moncao' ||
                                county=='monchique' ||
                                county=='mondim-de-basto' ||
                                county=='monforte' ||
                                county=='montalegre' ||
                                county=='montemor-o-novo' ||
                                county=='montemor-o-velho' ||
                                county=='montijo' ||
                                county=='mora' ||
                                county=='mortagua' ||
                                county=='moura' ||
                                county=='mourao' ||
                                county=='murca' ||
                                county=='murtosa' ||
                                county=='nazare' ||
                                county=='nelas' ||
                                county=='nisa' ||
                                county=='nordeste' ||
                                county=='obidos' ||
                                county=='odemira' ||
                                county=='odivelas' ||
                                county=='oeiras' ||
                                county=='oleiros' ||
                                county=='olhao' ||
                                county=='oliveira-de-azemeis' ||
                                county=='oliveira-de-frades' ||
                                county=='oliveira-do-bairro' ||
                                county=='oliveira-do-hospital' ||
                                county=='ourem' ||
                                county=='ourique' ||
                                county=='ovar' ||
                                county=='pacos-de-ferreira' ||
                                county=='palmela' ||
                                county=='pampilhosa-da-serra' ||
                                county=='paredes' ||
                                county=='paredes-de-coura' ||
                                county=='pedrogao-grande' ||
                                county=='penacova' ||
                                county=='penafiel' ||
                                county=='penalva-do-castelo' ||
                                county=='penamacor' ||
                                county=='penedono' ||
                                county=='penela' ||
                                county=='peniche' ||
                                county=='peso-da-regua' ||
                                county=='pinhel' ||
                                county=='pombal' ||
                                county=='ponta-delgada' ||
                                county=='ponta-do-sol' ||
                                county=='ponte-da-barca' ||
                                county=='ponte-de-lima' ||
                                county=='ponte-de-sor' ||
                                county=='portalegre' ||
                                county=='portel' ||
                                county=='portimao' ||
                                county=='porto' ||
                                county=='porto-de-mos' ||
                                county=='porto-moniz' ||
                                county=='porto-santo' ||
                                county=='povoa-de-lanhoso' ||
                                county=='povoa-de-varzim' ||
                                county=='povoacao' ||
                                county=='proenca-a-nova' ||
                                county=='redondo' ||
                                county=='reguengos-de-monsaraz' ||
                                county=='resende' ||
                                county=='ribeira-brava' ||
                                county=='ribeira-de-pena' ||
                                county=='ribeira-grande' ||
                                county=='rio-maior' ||
                                county=='sabrosa' ||
                                county=='sabugal' ||
                                county=='salvaterra-de-magos' ||
                                county=='santa-comba-dao' ||
                                county=='santa-cruz' ||
                                county=='santa-cruz-da-graciosa' ||
                                county=='santa-cruz-das-flores' ||
                                county=='santa-maria-da-feira' ||
                                county=='santa-marta-de-penaguiao' ||
                                county=='santana' ||
                                county=='santarem' ||
                                county=='santiago-do-cacem' ||
                                county=='santo-tirso' ||
                                county=='sao-bras-de-alportel' ||
                                county=='sao-joao-da-madeira' ||
                                county=='sao-joao-da-pesqueira' ||
                                county=='sao-pedro-do-sul' ||
                                county=='sao-roque-do-pico' ||
                                county=='sao-vicente' ||
                                county=='sardoal' ||
                                county=='satao' ||
                                county=='seia' ||
                                county=='seixal' ||
                                county=='sernancelhe' ||
                                county=='serpa' ||
                                county=='serta' ||
                                county=='sesimbra' ||
                                county=='setubal' ||
                                county=='sever-do-vouga' ||
                                county=='silves' ||
                                county=='sines' ||
                                county=='sintra' ||
                                county=='sobral-de-monte-agraco' ||
                                county=='soure' ||
                                county=='sousel' ||
                                county=='tabua' ||
                                county=='tabuaco' ||
                                county=='tarouca' ||
                                county=='tavira' ||
                                county=='terras-de-bouro' ||
                                county=='tomar' ||
                                county=='tondela' ||
                                county=='torre-de-moncorvo' ||
                                county=='torres-novas' ||
                                county=='torres-vedras' ||
                                county=='trancoso' ||
                                county=='trofa' ||
                                county=='vagos' ||
                                county=='vale-de-cambra' ||
                                county=='valenca' ||
                                county=='valongo' ||
                                county=='valpacos' ||
                                county=='velas' ||
                                county=='vendas-novas' ||
                                county=='viana-do-alentejo' ||
                                county=='viana-do-castelo' ||
                                county=='vidigueira' ||
                                county=='vieira-do-minho' ||
                                county=='vila-da-praia-da-vitoria' ||
                                county=='vila-de-rei' ||
                                county=='vila-do-bispo' ||
                                county=='vila-do-conde' ||
                                county=='vila-do-porto' ||
                                county=='vila-flor' ||
                                county=='vila-franca-de-xira' ||
                                county=='vila-franca-do-campo' ||
                                county=='vila-nova-da-barquinha' ||
                                county=='vila-nova-de-cerveira' ||
                                county=='vila-nova-de-famalicao' ||
                                county=='vila-nova-de-foz-coa' ||
                                county=='vila-nova-de-gaia' ||
                                county=='vila-nova-de-paiva' ||
                                county=='vila-nova-de-poiares' ||
                                county=='vila-pouca-de-aguiar' ||
                                county=='vila-real' ||
                                county=='vila-real-de-santo-antonio' ||
                                county=='vila-velha-de-rodao' ||
                                county=='vila-verde' ||
                                county=='vila-vicosa' ||
                                county=='vimioso' ||
                                county=='vinhais' ||
                                county=='viseu' ||
                                county=='vizela' ||
                                county=='vouzela' ) ? "" : "d-none"}>
                    {county_info != '' && (
                    <div class="box">
                        {county_info && county_info.map(county_inf => (
                            <div class={county_inf.image_county == null || county_inf.text_county == null ? "d-none" : ""}>
                                <div class="hero-area position-relative">
                                    <div class="container-fluid p-0 fix">
                                        <div class="row hero_row">
                                            <div class="col-sm-12 hero">
                                                <div class="desktop-bg">
                                                    <img class="img d-none d-md-block" src={"https://www.laresonline.pt"+county_inf.image_county} alt={"foto-concelho-"+county_inf.county} />
                                                </div>
                                                <div class="mobile-bg">
                                                    <img class="img" src="img/hero-small-bg.png" alt="cor-de-fundo-mobile" />
                                                    <div class="hero-caption-heading">
                                                        <h2>{county_inf.county}</h2>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="container">
                                        <div class="hero-caption-box">
                                            <div class="hero-caption-heading d-none d-md-block">
                                                <h2>{county_inf.county}</h2>
                                            </div>
                                            <div class="hero-caption-content" id="ex3">
                                                <p>{county_inf.text_county}</p>
                                            </div>  
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            ))}
                        </div>
                        )}
                    </div>

                    <div class="breadcrumb-area pt-60 pb-10">
                        <div class="container">
                            <div class="row">
                                <div class="col-xl-8 col-md-12 col-sm-12 col-xs-12 ipad_landscape_page_title">
                                    <div class={establishments_count == 0 ? "d-none" : "page-title"}>
                                    {establishments && establishments_count && (
                                        <ul class="list-inline">
                                            <li> <a href={environment_url}>Home</a> {" >"}</li>
                                            <li class={valen != 0 ? "pl-1" : "d-none"}> 
                                                {district != 0 || service != 0 || county != 0 ? <a title="Valência" href={"?valencia="+establishments[0].v_url}> {establishments[0].valence} </a> : 
                                                establishments[0].valence } {" >"}
                                            </li>
                                            <li class={valen == 'lares-e-residencias' ? "pl-1" : "d-none"}> 
                                                {service != 0 ? establishments[0].service_32 +" >" : "" } 
                                            </li>
                                            <li class={valen == 'apoio-domiciliario' ? "pl-1" : "d-none"}> 
                                                {service != 0 ? establishments[0].service_60 +" >" : "" } 
                                            </li>
                                            <li class={county != 0 || district != 0 ? "pl-1" : "d-none"}> 
                                                {county != 0 ? <a title="Distrito" href={footprintsDistrictLink()}> {establishments[0].distrito} </a> : "Distrito de "+
                                                establishments[0].distrito} {" >"}
                                            </li>
                                            <li class={county != 0 ? "pl-1" : "d-none"}> 
                                                {keywords != "" ? <a title="Concelho" href={footprintsCountyLink()} > {establishments[0].concelho}</a> : 
                                                establishments[0].concelho} {" >"} 
                                            </li>
                                            <li title="Palavra-chave" class={keywords == "" ? "d-none" : "pl-1"}>"{keywords.replaceAll("%", " ").charAt(0).toUpperCase() + keywords.slice(1)}" {" >"}</li>
                                            <li class={ordbyrec == 0 ? "d-none" : "pl-1"}>Mais recomendados {" >"}</li>
                                            <li class={ordbynew == 0 ? "d-none" : "pl-1"}>Mais recentes {" >"}</li>
                                            <li class={ordbyfav == 0 ? "d-none" : "pl-1"}>Favoritos {" >"}</li>
                                            <li class={wphoto == 0 ? "d-none" : "pl-1"}>Com foto {" >"}</li>
                                            <li class="pl-1">Resultados de Pesquisa</li>
                                        </ul>
                                        )}
                                        <br/>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-xs-12 ipad_landscape_dropdown">
                                    <div class="dropdown mb-2" id="ordernarDropdownDiv">
                                        <a type="text" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="filter-dropdown d-flex align-items-center arrowChangDropDown">
                                            <span> {ordbyfav == 1 ? 'Favoritos' : ordbynew == 1 ? 'Mais recentes' : 'Ordenar por'} </span>  
                                            <span class="icon-dropdown down_arrow d-none"> <img alt="icon-down" src="img/icon-down.svg"/></span>
                                            <span class="icon-dropdown up_arrow"> <img  alt="icon-up" src="img/icon-up.svg"/></span>
                                        </a>
                                        <div id="ordernarDropdown" class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <a class="dropdown-item" href={getResultsOrdNew()}>  Mais recentes  </a>
                                            <a class="dropdown-item" href={getResultsOrdFav()}>  Favoritos  </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* breadcrumb-area end main-content */} 

                    <div class="main-content">  
                        <div class="container container_ipad">
                            <div class="row row_search">
                                <div class="col-xl-2 col-lg-2 col-md-3 mobile-pesquisa-div">
                                    <aside class="content-sidebar">
                                        <div class="sidebar-widget pesquisa-widget">
                                            <div class="widget-heading Pesquisa-heading">
                                                    <h3>Pesquisa</h3>
                                                </div>
                                                <div>
                                                <Formik
                                                    initialValues={{ valence:valen, service: service, district: district, county: county, keywords: '', page_number:1 }}
                                                    validationSchema={this.validationSchemaSearch}
                                                    validateOnChange={true}
                                                    validateOnBlur={true}   
                                                    onSubmit={(values) => {
                                                        setTimeout(() => {
                                                            values.valence = values.valence ? values.valence : valen
                                                            values.service = values.service ? values.service : service
                                                            values.local = values.local ? values.local : 0;
                                                            values.keywords = values.keywords ? values.keywords : ""
                                                            console.log(JSON.stringify(values, null, 2));

                                                            function goToLink(){
                                                                let link = "";
                                                                link = (values?"?":"")+(values.valence && values.valence != 0? "valencia="+values.valence:"")+(!values.local && district ? "&distrito="+district : '')+(!values.local && county ? "&concelho="+county : '')+(values.local && values.local.substring(0,1) == 'd' ?"&distrito="+values.local.replace('distrito-',''):"")+(values.local && values.local.substring(0,1) == 'c' ? "&concelho="+values.local.replace('concelho-',''):"")+(values.keywords != "" ?"&palavras-chave="+values.keywords:"");
                                                                return link;
                                                            }
                                                            window.location.href = goToLink();
                                                        }, 400);
                                                    }}
                                                >
                                                {({
                                                    values,
                                                    handleSubmit,
                                                    handleChange,
                                                    isSubmitting,
                                                    setFieldValue,
                                                    setFieldTouched
                                                }) => (
                                                    <Form onSubmit={handleSubmit}>
                                                    <div id="sidebar-options-1"  class="sidebar-options mb-2">
                                                        <span>Selecione uma valência</span>
                                                        <select
                                                            class="custom-select"
                                                            default={values.valence}
                                                            value={values.valence ? values.valence : valen}
                                                            onChange={handleChange}
                                                            onFocus={hideHeader}
                                                            onBlur={showHeader}
                                                            name="valence"
                                                        >
                                                            <option value="0">Todas as valências</option>
                                                            {valences && valences.map(valence => (
                                                            <option value={valence.url}>{valence.name}</option>
                                                            ))}  
                                                        </select> 
                                                    </div>
                                                    <div id="sidebar-options-2"  class="sidebar-options mb-2">
                                                        <span>Local</span>
                                                    
                                                    {places && (
                                                    <div class="autocomplete">
                                                        <ThemeProvider theme={theme}>
                                                        <Autocomplete
                                                            options={places}
                                                            getOptionLabel={(places) => places.name}
                                                            onChange={(event, value) => value ? values.local = value.url : values.local = '00'} 
                                                            setFieldValue={setFieldValue}
                                                            defaultValue={ (this.params.get('distrito') == null && this.params.get('concelho') != null) ? {name: getLocalName('concelho-'+county), url: 'concelho-'+county} : (this.params.get('distrito') != null && this.params.get('concelho') == null) ? {name: getLocalName('distrito-'+district), url: 'distrito-'+district} : '00-00' }
                                                            className="autocomplete"
                                                            id="autocomplete"
                                                            renderInput={(params) => 
                                                            <TextField {...params} 
                                                                onClick={clearLocal}
                                                                onFocus={hideHeader}
                                                                onBlur={showHeader}
                                                                placeholder="Selecione o local"
                                                                InputProps={{...params.InputProps, disableUnderline: true}}
                                                                />}
                                                        />
                                                        </ThemeProvider>
                                                    </div>
                                                    )}
                                                </div>

                                                    <div id="sidebar-options-3"  class="sidebar-options mb-2">
                                                        <span>Palavras-chave</span>
                                                        <Field 
                                                            class="custom-select custom-select-key"
                                                            name="keywords" 
                                                            type="text" 
                                                            id="keywords_input"
                                                            placeholder="Palavras-chave"
                                                            onFocus={hideHeader}
                                                            onBlur={showHeader}
                                                            value={values.keywords ? values.keywords : keywords}
                                                            onClick={clearKeywords}
                                                        />
                                                    </div>
                                                        <button type="submit" class="sidebar-btn sidebar-btn_style" onClick={() => this.setState({progress: 100})}>Pesquisar</button>
                                                    </Form>
                                                    )}
                                                </Formik>
                                                </div>
                                            </div>
                                            
                                            <div class={establishments_count == 0 ? "d-none" : "sidebar-widget sidebar-widget-checkbox"}>
                                                <div class="filter-menu-heading">
                                                    <span>Filtro por:</span>
                                                </div>

                                                    <Formik
                                                        initialValues={{ valence:valen, service: service, district:district, county:county, keywords:keywords, ordbyrec:ordbyrec, wphoto:wphoto, page_number:1 }}
                                                        validateOnChange={true}
                                                        validateOnBlur={true}   
                                                        onSubmit={(values) => {
                                                            setTimeout(() => {
                                                                values.valence = values.valence ? values.valence : valen
                                                                values.service = values.service ? values.service : service
                                                                values.district = values.district ? values.district.substring(0,1) == 'd' ? values.district.replace('distrito-','') : district : district
                                                                values.county = values.county ? values.county.substring(0,1) == 'c' ? values.county.replace('concelho-','') : county : county
                                                                values.keywords = values.keywords? values.keywords : keywords
                                                                values.ordbyrec = values.ordbyrec == 1 ? 1 : 0
                                                                values.wphoto = values.wphoto == 1 ? 1 : 0
                                                                //console.log(JSON.stringify(values, null, 2));
                                                                function goToLink(){
                                                                    let link = "";
                                                                    link = (values ? "?":"")+(values.valence?"valencia="+values.valence:"")+(values.service?"&tipologia="+values.service:"")+(values.district != 0 && values.county == 0 ?"&distrito="+values.district:"")+(values.county != 0 ?"&concelho="+values.county:"")+(values.keywords != "" ? "&palavras-chave="+values.keywords:"")+(values.ordbyrec == 1 ?"&mais-recomendados":"")+(values.wphoto == 1 ?"&com-foto":"");
                                                                    return link;
                                                                }
                                                                window.location.href = goToLink();
                                                            }, 400);
                                                        }}
                                                    >
                                                    {({
                                                        values,
                                                        handleSubmit,
                                                        handleChange,
                                                        isSubmitting
                                                    }) => (
                                                        <Form onSubmit={handleSubmit}>
                                                            <div class="filter-menu">
                                                                <nav id="">
                                                                    <ul>
                                                                        <li class={valen == 0 ? "single-menu-item" : "d-none"}>
                                                                            <p>Valência</p>
                                                                            <div class="custom-check-box">
                                                                                <ul>
                                                                                {valences && valences.map(valence => (
                                                                                    <li>
                                                                                        <span>
                                                                                            <input 
                                                                                                type="radio" 
                                                                                                id={'radio'+valence.id}
                                                                                                name="valence"
                                                                                                className="radio_valences"
                                                                                                value={valence.url}
                                                                                                onChange={handleChange}
                                                                                                onClick={(e)=>{if(e && e.target && e.target.value == values.valence) {e.target.checked = false;values.valence=null}}}
                                                                                            />
                                                                                            <label for={'radio'+valence.id}><div class="label-format">{valence.name}</div></label>
                                                                                        </span>
                                                                                    </li>
                                                                                    ))}
                                                                                </ul>
                                                                            </div>
                                                                        </li>

                                                                        <li class={valen == 'lares-e-residencias' ? "single-menu-item mt-2" : "d-none"}>
                                                                            <p>Tipo</p>
                                                                            <div class="custom-check-box">
                                                                                <ul>
                                                                                {services_32 && services_32.map(servic_32 => (
                                                                                    <li>
                                                                                        <span>
                                                                                            <input 
                                                                                                type="radio" 
                                                                                                id={'radio_service'+servic_32.url}
                                                                                                className="radio_services"
                                                                                                name="service"
                                                                                                value={servic_32.url}
                                                                                                onChange={handleChange}
                                                                                                onClick={(e)=>{this.getNrEstablishmentsByCounty(e.target.value); 
                                                                                                               if(e && e.target && e.target.value == values.service) {e.target.checked = false;values.service=null}}}
                                                                                            />
                                                                                            <label for={'radio_service'+servic_32.url}><div class="label-format">{servic_32.name}</div></label>
                                                                                        </span>
                                                                                    </li>
                                                                                    ))}
                                                                                </ul>
                                                                            </div>
                                                                        </li>

                                                                        <li class={valen == 'apoio-domiciliario'? "single-menu-item mt-2" : "d-none"}>
                                                                            <p>Tipo</p>
                                                                            <div class="custom-check-box">
                                                                                <ul>
                                                                                {services_60 && services_60.map(servic_60 => (
                                                                                    <li>
                                                                                        <span>
                                                                                            <input 
                                                                                                type="radio" 
                                                                                                id={'radio_service'+servic_60.url}
                                                                                                className="radio_services"
                                                                                                name="service"
                                                                                                value={servic_60.url}
                                                                                                onChange={handleChange}
                                                                                                onClick={(e)=>{this.getNrEstablishmentsByCounty(e.target.value); if(e && e.target && e.target.value == values.service) {e.target.checked = false;values.service=null}}}
                                                                                            />
                                                                                            <label for={'radio_service'+servic_60.url}><div class="label-format">{servic_60.name}</div></label>
                                                                                        </span>
                                                                                    </li>
                                                                                    ))}
                                                                                </ul>
                                                                            </div>
                                                                        </li>
                                                                    
                                                                        <div class={district != 0 && county == 0 && nrs_by_county != "" ? "" : "d-none" }>
                                                                            <li class="single-menu-item">
                                                                                <p class="side-bar-title-counties">Concelhos</p>
                                                                                <div class="custom-check-box">
                                                                                    <ul>
                                                                                    {nrs_by_county && nrs_by_county.map(nr_by_county => (
                                                                                        <li>                    
                                                                                            <div>
                                                                                            <span>
                                                                                                <input 
                                                                                                    type="radio" 
                                                                                                    id={'radiocounty'+nr_by_county.url} 
                                                                                                    name="county"
                                                                                                    className="radio_counties"
                                                                                                    value={nr_by_county.url}
                                                                                                    onChange={handleChange}
                                                                                                    onClick={(e)=>{if(e && e.target && e.target.value == values.county) {e.target.checked = false;values.county=null}}}
                                                                                                /><label for={'radiocounty'+nr_by_county.url}><div class="label-format">{nr_by_county.name} ({nr_by_county.count_establishments}) </div> </label>
                                                                                            </span>
                                                                                            </div>
                                                                                        </li>
                                                                                        
                                                                                    ))}
                                                                                    </ul>

                                                                                </div>
                                                                            </li>
                                                                        </div>

                                                                        <li class="single-menu-item">
                                                                            <div class="custom-check-box border-check">
                                                                                <ul>
                                                                                    <li>
                                                                                        <span>
                                                                                            <input 
                                                                                                type="checkbox" 
                                                                                                id="check14" 
                                                                                                name="ordbyrec"
                                                                                                value={values.ordbyrec}
                                                                                                onClick={(e)=>{values.ordbyrec=Number(!values.ordbyrec);document.getElementById(e.target.id).checked=values.ordbyrec==1}}
                                                                                            />
                                                                                            <label for="check14"><div class="label-format">Mais recomendados</div></label>
                                                                                        </span>
                                                                                    </li>
                                                                                    <li>
                                                                                        <span>
                                                                                            <input 
                                                                                                type="checkbox" 
                                                                                                id="check15" 
                                                                                                name="wphoto"
                                                                                                value={values.wphoto}
                                                                                                onClick={(e)=>{values.wphoto=Number(!values.wphoto);document.getElementById(e.target.id).checked=values.wphoto==1}}
                                                                                            />
                                                                                            <label for="check15"><div class="label-format">Entradas com foto</div></label>
                                                                                        </span>
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <button class="sidebar-btn" onClick={() => this.setState({progress: 100})}>Filtrar</button>
                                                                        </li>
                                                                    </ul>
                                                                </nav>
                                                            </div>
                                                        </Form>
                                                    )}
                                                </Formik>
                                            </div>
                                        </aside>
                                    </div>

                                    <div class="row col-md-12 col-sm-12 col-xs-12 filtors-button-for-mobile div_filtors_1">
                                        <div class={establishments_count == 0 ? "d-none" : ""}>
                                            <div class="only-for-mobile filtors-button-for-mobile div_filtors_2">
                                                <button type="button" onClick={this.showFiltersMobile} class="button-border-2 d-md-none d-lg-none d-xl-none btn-filter-show-mob">Filtros</button>
                                            </div>
                                        </div>
                                        
                                        {/* FILTERS -- MOBILE */} 
                                        <div id="filter_full_section" class="d-none">
                                            <div class="row col-md-12 col-sm-12 col-xs-12 filtors_mobile_div">
                                                <div class="only-for-mobile filtors-button-for-mobile div_filter_remove_icon">
                                                    <button type="button" onClick={this.hideFiltersMobile} class="filter_remove_icon_div">
                                                        <img src="img/baseline-close-24-px.png"  alt="filter_remove_icon" class="filter_remove_icon"/>
                                                    </button>
                                                    <div align="center" class="d-md-none d-lg-none d-xl-none filtros" id="filtros">Filtros</div>
                                                    <button class="Clear-All" onClick={this.resetFiltersMobile}>Limpar</button>
                                                </div>
                                            </div>
                                            
                                            <div class="row col-md-12 col-sm-12 col-xs-12 filter_check_mobile_div">
                                                <div class="col-sm-12" id="filters-container">
                                                    <Formik
                                                    initialValues={{ valence:valen, service: service, district:district, county:county, keywords:keywords, ordbyrecmob:ordbyrec, wphotomob:wphoto, page_number:1 }}
                                                    validateOnChange={true}
                                                    validateOnBlur={true}   
                                                    onSubmit={(values) => {
                                                        setTimeout(() => {
                                                            values.valence = values.valence ? values.valence : valen
                                                            values.service = values.service ? values.service : service
                                                            values.county = values.county ? values.county : county
                                                            values.keywords = values.keywords? values.keywords : keywords
                                                            values.ordbyrecmob = values.ordbyrecmob == 1 ? 1 : 0
                                                            values.wphotomob = values.wphotomob == 1 ? 1 : 0
                                                            console.log(JSON.stringify(values, null, 2));
                                                            function goToLink(){
                                                                let link = "";
                                                                link = (values ? "?":"")+(values.valence?"valencia="+values.valence:"")+(values.service?"&tipologia="+values.service:"")+(values.district != 0 ?"&district="+values.district:"")+(values.county != 0 ?"&county="+values.county:"")+(values.keywords != ""?"&palavras-chave="+values.keywords:"")+(values.ordbyrecmob == 1 ?"&mais-recomendados":"")+(values.wphotomob == 1 ?"&com-foto":"");
                                                                return link;
                                                            }
                                                            window.location.href = goToLink();
                                                            }, 400);
                                                                }}
                                                            >
                                                            {({
                                                            values,
                                                            handleSubmit,
                                                            handleChange,
                                                            handleReset,
                                                            isSubmitting
                                                            }) => (
                                                        <Form onSubmit={handleSubmit}>

                                                            <div id="filtros_div">
                                                                <ul class="d-md-none d-lg-none d-xl-none ul-valencia">
                                                                    <li class={valen == 0 ? "single-menu-item" : "d-none"}>
                                                                        <p class="p-valencia">Valência</p>
                                                                        <div class="custom-check-box">
                                                                            <ul>
                                                                            {valences && valences.map(valence => (
                                                                                <li>
                                                                                    <span>
                                                                                    <input 
                                                                                        class="mobile_filter_checkbox"
                                                                                        type="radio" 
                                                                                        id={'radio_mobile'+valence.id}
                                                                                        name="valence"
                                                                                        value={valence.url}
                                                                                        onChange={handleChange}
                                                                                        onClick={(e)=>{if(e && e.target && e.target.value == values.valence) {e.target.checked = false;values.valence=null}}}
                                                                                    />
                                                                                    <label for={'radio_mobile'+valence.id}>{valence.name}</label>
                                                                                    </span>
                                                                                </li>
                                                                                ))}
                                                                            </ul>
                                                                        </div>
                                                                    </li>

                                                                    <li class={valen == 'lares-e-residencias'? "single-menu-item mt-2" : "d-none"}>
                                                                        <p>Tipo</p>
                                                                        <div class="custom-check-box">
                                                                            <ul>
                                                                            {services_32 && services_32.map(servic => (
                                                                                <li>
                                                                                    <span>
                                                                                        <input 
                                                                                            class="mobile_filter_checkbox"
                                                                                            type="radio" 
                                                                                            id={'mobile_radio_service'+servic.url}
                                                                                            name="service"
                                                                                            value={servic.url}
                                                                                            onChange={handleChange}
                                                                                            onClick={(e)=>{if(e && e.target && e.target.value == values.service) {e.target.checked = false;values.service=null}}}
                                                                                        />
                                                                                        <label for={'mobile_radio_service'+servic.url}>{servic.name}</label>
                                                                                    </span>
                                                                                </li>
                                                                                ))}
                                                                            </ul>
                                                                        </div>
                                                                    </li>
                                                                    
                                                                    <li class={valen == 'apoio-domiciliario'? "single-menu-item mt-2" : "d-none"}>
                                                                        <p>Tipo</p>
                                                                        <div class="custom-check-box">
                                                                            <ul>
                                                                            {services_60 && services_60.map(servic_60 => (
                                                                                <li>
                                                                                    <span>
                                                                                        <input 
                                                                                            class="mobile_filter_checkbox"
                                                                                            type="radio" 
                                                                                            id={'mobile_radio_service'+servic_60.url}
                                                                                            name="service"
                                                                                            value={servic_60.url}
                                                                                            onChange={handleChange}
                                                                                            onClick={(e)=>{if(e && e.target && e.target.value == values.service) {e.target.checked = false;values.service=null}}}
                                                                                        />
                                                                                        <label for={'mobile_radio_service'+servic_60.url}>{servic_60.name}</label>
                                                                                    </span>
                                                                                </li>
                                                                                ))}
                                                                            </ul>
                                                                        </div>
                                                                    </li>

                                                                    <li class="single-menu-item">
                                                                        <div class="custom-check-box border-check">
                                                                            <ul>
                                                                                <li>
                                                                                    <span>
                                                                                    <input 
                                                                                        class="mobile_filter_checkbox"
                                                                                        type="checkbox" 
                                                                                        id="checkbox_ordbyrec_mobile"
                                                                                        name="ordbyrecmob"
                                                                                        value={values.ordbyrecmob}
                                                                                        onClick={(e)=>{values.ordbyrecmob=Number(!values.ordbyrecmob);document.getElementById(e.target.id).checked=values.ordbyrecmob==1}}
                                                                                        // onChange={handleChange}
                                                                                        />
                                                                                        <label for="checkbox_ordbyrec_mobile">Mais recomendados</label>
                                                                                    </span>
                                                                                </li>
                                                                                <li>
                                                                                    <span>
                                                                                        <input 
                                                                                            class="mobile_filter_checkbox"
                                                                                            type="checkbox" 
                                                                                            id="checkbox_wphoto_mobile" 
                                                                                            name="wphotomob"
                                                                                            value={values.wphotomob}
                                                                                            onClick={(e)=>{values.wphotomob=Number(!values.wphotomob);document.getElementById(e.target.id).checked=values.wphotomob==1}}
                                                                                            // onChange={handleChange}
                                                                                        />
                                                                                        <label for="checkbox_wphoto_mobile">Apenas entradas com foto
                                                                                        </label>
                                                                                    </span>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </div>

                                                            <div class="d-md-none d-lg-none d-xl-none btn-aplicar-mobile">
                                                                <button class="mobile-filter-button sidebar-btn">Aplicar</button>
                                                            </div>
                                                        </Form> )}
                                                    </Formik>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* END FILTER MOBILE */}

                                    
                                    <div class="col-xl-10 col-lg-10 col-md-9 second-row">

                                        {/* SEM RESULTADOS - HEADER */}
{/*                                         <div class={establishments_count == 0 ? "" : "d-none"}>
                                            <div class="row">
                                                <div class="col-xl-8 col-md-8 col-sm-12 col-xs-12 section-title_1">
                                                    <div class="section-title">
                                                        {valences && places && valences.map(valence => places.map(place => (
                                                            <h5 class={valence.url == valen && place.url == ('distrito-'+district || 'concelho-'+county) ? "" : "d-none"}>{valence.name}: 0 Resultados Encontrados em {place.name}</h5>  
                                                        )))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}

                                        {/* SEM RESULTADOS - OUTRAS OFERTAS */}
                                        <div class={establishments_count == 0 ? "no-results" : "d-none"}> 
                                            <p>Lamentamos, mas a sua pesquisa não teve sucesso.</p>

                                            <h1>Descubra <a href={district != 0 ? "?valencia=lares-e-residencias&distrito="+district : county != 0 ? "?valencia=lares-e-residencias&concelho="+county : ''}>outras ofertas</a> na mesma área.</h1>
                                        </div>

                                        {/* CONTAGEM DE RESULTADOS */}
                                        <div class={this.state.progress == 100 ? "d-none" : "loading-bar-div"}>
                                            <CircularProgress className="loading-bar"/>
                                            {/* <LinearProgress className="loading-bar"/> */}
                                            <p>Estamos a preparar os melhores resultados para si</p>
                                        </div>

                                        <div class="col-lg-10 col-md-12">
                                            <div class={establishments_count == 0 ? "d-none" : ""}>
                                                {establishments && establishments_count && (
                                                <div class="row">
                                                    <div class="col-xl-12 col-md-12 col-sm-12 col-xs-12 section-title_1">
                                                        <div class="section-title"> 
                                                            {establishments && establishments_count && (
                                                            <h1 id="h1">{establishments_count} {valen != 0 && service == 0 ? establishments[0].valence + " para Idosos " : valen != 0 && service != 0 ? establishments[0].valence + " para Idosos" + " (" + (establishments[0].service_32 != null ? establishments[0].service_32 : (establishments[0].service_60 == 'Apoio Domiciliário Integrado' ? 'ADI' : establishments[0].service_60 == 'Serviço de Apoio Domiciliário' ? 'SAD' : '')  ) +")" : "Equipamentos e Serviços para Idosos" } {county != 0 ? " em "+ establishments[0].concelho : district != 0 ? " em "+establishments[0].distrito : " em Portugal"} {(resultspage != 1 ? " (página " + resultspage + "/"+ parseInt((establishments_count/10)+1) + ")" : '')}</h1>  
                                                            )}  
                                                        </div> 

                                                        <div class="section-title-mobile"> 
                                                            <h1 id="h1">{establishments_count} {valen != 0 && service == 0 ? establishments[0].valence + " para Idosos " : valen != 0 && service != 0 ? establishments[0].valence + " para Idosos " : "Equipamentos e Serviços para Idosos" } {county != 0 ? " em "+ establishments[0].concelho : district != 0 ? " em "+establishments[0].distrito : " em Portugal"} {(resultspage != 1 ? " (página " + resultspage + "/"+ parseInt((establishments_count/10)+1) + ")" : '')}</h1>    
                                                        </div>
                                                    </div>
                                                </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* RESULTADOS DE EQUIPAMENTOS */}
                                            {establishments && establishments.map(establishment => ( 
                                                <div onMouseOver={(e) => changeColors(e)} onMouseLeave={removeColors} id="item-box" class="row item-box no-gutters col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 md_left"> 
                                                    <div id="item_thumb_div" class="col-xl-4 col-lg-4 col-md-4 item_thumb_div">
                                                        <div class="item-thumb">
                                                            <a title={establishment.name} href={environment_url+"/pt/valencia/"+establishment.v_url+"/equipamento/"+establishment.e_url+"/"}>
                                                                {establishment.photos_disabled == 1 ? 
                                                                    (<img id="item-img" class="img" src={"img/establishment-360x250.jpg"} alt={"foto-do-estabelecimento-"+establishment.name}/>) 
                                                                    : 
                                                                    (<img id="item-img" class="img" src={"https://www.laresonline.pt" + establishment.photo_path_beg + "THUMBS-750x530-ADAPTIVE/" + establishment.photo_path_end} onError={(e) => {establishment.photo_path ? e.target.src = "https://www.laresonline.pt"+ establishment.photo_path : e.target.src = "img/establishment-360x250.jpg"}} alt={"foto-do-estabelecimento-"+establishment.name} />)
                                                                }
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-8 col-lg-8 col-md-8 item_content_div">
                                                        <div class="item-content">
                                                            <div class="item-content-top d-flex justify-content-between">
                                                                <div class="content-top-left d-md-none d-lg-none d-xl-none">
                                                                    <span id="content-top-left-valence">{establishment.valence}</span>
                                                                    <h2>
                                                                        <a title={establishment.name} href={environment_url + "/pt/valencia/"+establishment.v_url+"/equipamento/"+establishment.e_url+"/"}>{establishment.name}</a>
                                                                    </h2>
                                                                    <div class="address">
                                                                        <span class="map_icon pr-3"> <img src="img/Oval-big.svg" alt="icon-do-mapa" /></span>
                                                                        <span class="location">{" "}{establishment.freguesia + ", " + establishment.concelho + ", " + establishment.distrito}</span>
                                                                    </div>
                                                                </div>

                                                                <div class="content-top-left mobile_filter_button_div full_width_address">
                                                                    <span>{establishment.valence}</span>
                                                                    <h2>
                                                                        <a title={establishment.name} id="establishment-title" class="" href={environment_url + "/pt/valencia/"+establishment.v_url+"/equipamento/"+establishment.e_url+"/"}>{establishment.name}</a>
                                                                    </h2>
                                                                    <div class="address">
                                                                        <p class="map_icon"> <img src="img/Oval-small.svg" alt="icon-da-localidade" />{" "}{establishment.freguesia + ", " + establishment.concelho + ", " + establishment.distrito}</p>
                                                                    </div>
                                                                </div>

                                                                <div class={establishment.in_social_charter == 1 ? "" : "d-none"}>
                                                                    <div class="certo" title="Licenciado pela Segurança Social">
                                                                        <i class="fa fa-check fna-pull-left fa-border rounded-circle certo2"></i>
                                                                    </div>
                                                                </div>
                                                                <div class={establishment.in_social_charter == null ? "" : "d-none"}>
                                                                    <div class="certo" title="Ainda sem e/ou processo de licenciamento">
                                                                        <i class="fa fa-check fa-pull-left fa-border rounded-circle certo3"></i>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            
                                                            {/* SERVIÇOS, FAVORITOS E RECOMENDAÇOES MOBILE */}
                                                            <div class="item-content-middle d-flex align-items-center justify-content-between">
                                                                <div class="new-left col-md-12 col-sm-12 col-xl-12">

                                                                    {/* casos em que valência é lares e residencias - serviço 32 (4 quadrados) */}
                                                                    <div class={establishment.v_url == 'lares-e-residencias' ? "" : "d-none"}>
                                                                    
                                                                        <ul class="list-inline">

                                                                            <li class={establishment.valence ? "zero-li" : "d-none"}>
                                                                                <a><img src={"img/lares-online-alojamento-permanente.svg"} alt="icon-da-valencia"/>
                                                                                    <span class="">{establishment.valence}</span>
                                                                                </a>
                                                                            </li>

                                                                            <li class="first-li hotel">
                                                                                <a><img src={establishment.service_32 == 'Hotel' ? "img/icon-hotel.svg" : 
                                                                                                establishment.service_32 == 'ERPI' ? "img/icon-erpi.svg" :
                                                                                                establishment.service_32 == 'AL' ? "img/icon-alocal.svg" :
                                                                                                establishment.service_32 == 'Casa Particular' ? "img/icon-particular.svg" :
                                                                                                establishment.service_32 == 'UCCI' ? "img/icon-UCCI-small.svg" :
                                                                                                establishment.service_32 == 'UCRM' ? "img/icon-UCRM-small.svg" :""} alt="icon-da-tipologia-lares-e-residências"/>
                                                                                    <span class="">{establishment.service_32}</span>
                                                                                </a>
                                                                            </li>

                                                                            <li class="second-li">
                                                                                <a>
                                                                                    <span class="nicon"><img src="img/heart.svg" alt="icon-favoritos"/></span>
                                                                                    <span class="ntext">{establishment.nr_fav == 0 ? "" : establishment.nr_fav}{" "}{establishment.nr_fav == 1 ? "Favorito" : "Favoritos"}</span>
                                                                                </a>
                                                                            </li>
                                                                            <li class="third-li"> 
                                                                                <a><img src="img/star.svg" alt="icon-recomendações"/>
                                                                                    <span>{establishment.nr_rec == 0 ? "" : establishment.nr_rec}{" "}{establishment.nr_rec == 1 ? "Recomendação" : "Recomendações"}</span>
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>


                                                                {/* casos em que valência é apoio domiciliario - serviço 60 (4 quadrados) */}
                                                                    <div class={establishment.v_url == 'apoio-domiciliario' ? "" : "d-none"}>
                                                                    
                                                                        <ul class="list-inline">

                                                                            <li class={establishment.valence ? "zero-li" : "d-none"}>
                                                                                <a><img src={"img/lares-online-servicos-domicilio.svg"} alt="icon-da-valencia"/>
                                                                                    <span class="pl-2 pr-2">{establishment.valence}</span>
                                                                                </a>
                                                                            </li>

                                                                            <li class="first-li hotel">
                                                                                <a><img src={establishment.service_60 == 'Serviço de Apoio Domiciliário' ? "img/icon-SAD-small.svg" : 
                                                                                                establishment.service_60 == 'Apoio Domiciliário Integrado' ? "img/icon-ADI-small.svg" :""} alt="icon-da-tipologia-apoio-domiciliário"/>
                                                                                    <span class="">{establishment.service_60 == 'Serviço de Apoio Domiciliário' ? 'SAD' : establishment.service_60 == 'Apoio Domiciliário Integrado' ? 'ADI' : '' }</span>
                                                                                </a>
                                                                            </li>

                                                                            <li class="second-li">
                                                                                <a>
                                                                                    <span class="nicon"><img src="img/heart.svg" alt="icon-favoritos"/></span>
                                                                                    <span class="ntext">{establishment.nr_fav == 0 ? "" : establishment.nr_fav}{" "}{establishment.nr_fav == 1 ? "Favorito" : "Favoritos"}</span>
                                                                                </a>
                                                                            </li>
                                                                            <li class="third-li"> 
                                                                                <a><img src="img/star.svg" alt="icon-recomendações"/>
                                                                                    <span>{establishment.nr_rec == 0 ? "" : establishment.nr_rec}{" "}{establishment.nr_rec == 1 ? "Recomendação" : "Recomendações"}</span>
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>    


                                                                    <div class={(establishment.v_url == 'centros-de-dia' || establishment.v_url == 'centros-de-convivio' || establishment.v_url == 'cuidados-continuados') ? "" : "d-none"}>
                                                                    
                                                                        <ul class="list-inline">

                                                                            <li class={(establishment.v_url == 'centros-de-convivio' || establishment.v_url == 'cuidados-continuados') ? "zero-li-3squares" : "d-none"}>
                                                                                <a><img src={establishment.v_url == 'centros-de-convivio' ? "img/lares-online-centros-dia.svg" :
                                                                                             establishment.v_url == 'cuidados-continuados' ? "img/lares-online-cuidados-continuados.svg" :  ""} alt="icon-da-valencia"/>
                                                                                    <span class="">{establishment.valence}</span>   
                                                                                </a>
                                                                            </li>

                                                                            <li class={establishment.v_url == 'centros-de-dia' ? "zero-0-li-3squares" : "d-none"}>
                                                                                <a><img src="img/lares-online-centros-dia.svg" alt="icon-da-valencia"/>
                                                                                    <span class="">{establishment.valence}</span>   
                                                                                </a>
                                                                            </li>

                                                                            <li class="second-li-3squares">
                                                                                <a>
                                                                                    <span class="nicon"><img src="img/heart.svg" alt="icon-favoritos"/></span>
                                                                                    <span class="ntext">{establishment.nr_fav == 0 ? "" : establishment.nr_fav}{" "}{establishment.nr_fav == 1 ? "Favorito" : "Favoritos"}</span>  
                                                                                </a>
                                                                            </li>
                                                                            <li class="third-li-3squares"> 
                                                                                <a><img src="img/star.svg" alt="icon-recomendações"/>
                                                                                    <span>{establishment.nr_rec == 0 ? "" : establishment.nr_rec}{" "}{establishment.nr_rec == 1 ? "Recomendação" : "Recomendações"}</span>
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>

                                                                </div>


                                                                {/* SERVIÇOS, FAVORITOS, RECOMENDAÇOES E DESCRIÇAO --- PC */}
                                                                <div class="left">
                                                                    <ul class="list-inline">
                                                                        <li class={establishment.service_60 ? "zero_li_pc" : "d-none"}>
                                                                            <a><img src={establishment.service_60 == 'Serviço de Apoio Domiciliário' ? "img/icon-SAD-small.svg" : 
                                                                                                establishment.service_60 == 'Apoio Domiciliário Integrado' ? "img/icon-ADI-small.svg" :""}  alt="icon-tipologia-apoio-domiciliario" />
                                                                                <span title={establishment.service_60 == 'Serviço de Apoio Domiciliário' ? 'Serviço de Apoio Domiciliário' : establishment.service_60 == 'Apoio Domiciliário Integrado' ? 'Apoio Domiciliário Integrado' : '' } class="service32 pl-2 pr-1">{establishment.service_60 == 'Serviço de Apoio Domiciliário' ? 'SAD' : establishment.service_60 == 'Apoio Domiciliário Integrado' ? 'ADI' : '' }{" "}</span>
                                                                            </a>
                                                                        </li>
                                                                        <li class={establishment.service_32 ? "first_li" : "d-none"}>
                                                                            <a><img src={establishment.service_32 == 'Hotel' ? "img/icon-hotel.svg" : 
                                                                                                establishment.service_32 == 'ERPI' ? "img/icon-erpi.svg" :
                                                                                                establishment.service_32 == 'AL' ? "img/icon-alocal.svg" :
                                                                                                establishment.service_32 == 'Casa Particular' ? "img/icon-particular.svg" :
                                                                                                establishment.service_32 == 'UCCI' ? "img/icon-UCCI-small.svg" :
                                                                                                establishment.service_32 == 'UCRM' ? "img/icon-UCRM-small.svg" :""}  alt="icon-tipologia-lares" /><span class="service32 pl-2 pr-1">{establishment.service_32}{" "}</span></a>
                                                                        </li>
                                                                        <li class="">
                                                                            <a><img src="img/star.svg" alt="icon-recomendações" /><span class="recommendations pl-1 pr-1">{establishment.nr_rec == 0 ? "" : establishment.nr_rec}{" "}{establishment.nr_rec == 1 ? "Recomendação " : "Recomendações "}</span></a>
                                                                        </li>
                                                                        <li class="">
                                                                            <a>
                                                                                <img src="img/heart.svg" alt="icon-favoritos" /><span class="favorites pl-1 pr-1">{establishment.nr_fav == 0 ? "" : establishment.nr_fav}{" "}{establishment.nr_fav == 1 ? "Favorito " : "Favoritos "}</span>
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <div id="item-button" class="right">
                                                                    <span>
                                                                        <a id="item-button-link" onMouseOver={(e) => removeUnderline(e)} href={environment_url + "/pt/valencia/"+establishment.v_url+"/equipamento/"+establishment.e_url+"/"} class="button-border">Ver detalhes</a>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div class="item-last">
                                                                <p>{establishment.short_description_pt}</p>
                                                                {/* <p>{establishment.short_description_pt == null ? establishment.short_description_pt : establishment.short_description_pt.length < 75 ? establishment.short_description_pt : establishment.short_description_pt.substring(0,70) + " (...)"}</p> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}    
                                        </div> 
                                    </div>

                                    {/* PAGINAÇAO --- PC */}
                                    {establishments && (
                                    <div class="row justify-content-center">
                                        <ul class="pagination breadcrumb-area">
                                            {page_number > 1 && (
                                              <li class={page_number === 1 ?"page-item p-1 d-none":"page-item p-1"}>
                                                <a title={"Página "+(page_number-1)} class="page-link" href={getLink()+(page_number-1)}>{page_number-1} </a>
                                              </li>
                                            )}
                                            <li class={(establishments_count < 11) ? "d-none" : "page-item p-1 active"}>
                                                <span title={"Página "+page_number} class="page-link page-link-active">{page_number} <span class="sr-only">(current)</span></span>
                                            </li>
                                            {pagination()}
                                        </ul>
                                    </div>
                                    )}

                                    <div class="col-xs-4 col-md-4 sidebar-options2 breadcrumb-area"></div>

                                    {/* PAGINAÇAO MOBILE */}
                                    <div class="row item-filtering-btn mb-30">
                                        <div class={page_number <= 1 ? "invisible col-sm-6 col-6": "col-sm-6 col-6"} >
                                          {page_number > 1 && (
                                            <a href={getLink()+(page_number-1)} class="button-border-2">Anterior</a>
                                          )}
                                        </div>
                                        <div class={(establishments_count/10) < page_number+2 ? "d-none": "col-sm-6 col-6 text-right"}>
                                            <a href={getLink()+(page_number+1)} class="button-border-2">Seguinte</a>
                                        </div>
                                    </div>
                                </div>     
                            </div>
                            {/* main-content end */}
                    
                            {/* GUIAS LOCAIS - ANTES DO FOOTER */}
                            {local_guides && local_guides.map(local_guide => (
                            <div class={local_guide.county_id === 5 || 
                                        local_guide.county_id === 41 || 
                                        local_guide.county_id === 49 || 
                                        local_guide.county_id === 152 || 
                                        local_guide.county_id === 153 || 
                                        local_guide.county_id === 212 ? "container" : "d-none"}>
                                <div class="about-area pb-165">
                                    <div class="local-guides">
                                        <div class="row align-items-center ">
                                            <div class="row">
                                                <div class="col-xl-12">
                                                    <div class="about-box">
                                                        <div class="row align-items-center">
                                                            <div class="col-lg-5 col-md-5 aboutleft">
                                                                <div class="about-left d-flex justify-content-center">
                                                                    <img class="img" src={"https://www.laresonline.pt"+local_guide.seo_img} alt="foto-guia-local" />
                                                                    <p class="about-left-p">{local_guide.concelho}</p>
                                                                    <a class="ler-mais-btn" href={environment_url + "/pt/blog/"+local_guide.url} alt="Ler mais">Ler mais</a>  
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-7 col-md-7 about-right">
                                                                <div class="about-caption pr-4">
                                                                    <h4 class="mb-3">{local_guide.title}</h4>
                                                                    <p class="pr-3">{local_guide.seo_text}{" "}(…){" "}
                                                                    <a class="ler-mais-btn2" href={environment_url + "/pt/blog/"+local_guide.url}>Ler mais</a></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> ))}
                        </main>
            
                        <MainFooter/>
                    </div> 
                    )}}

export default ResultsPageView;
